<template>
  <div
    class="person-container"
    v-if="person.Id"
  >
    <span class="text-bold">{{ person.Name }}</span>
    <div class="row no-wrap justify-between">
      <span>{{ person.Post }}</span>
      <span>{{ getAddress }}</span>
    </div>
    <!-- <div class="row no-wrap">
      <span v-html="getClients" />
    </div> -->
    <span style="white-space: break-spaces" v-html="person.Contacts" />

    <!-- tags list -->
  </div>
</template>

<script lang="ts">
import { date } from "quasar";
import { Component, Prop, Vue } from "vue-facing-decorator";
import { PersonInList } from "../../../../models/interfaces/entity-settings/querytable/querytable";

@Component({
  name: "PersonCard",
})
export default class PersonCard extends Vue {
  // === PROPS ===
  @Prop({ required: true }) readonly person!: PersonInList;

  get getCreateTime() {
    return date.formatDate(this.person.CreateTime, "HH:mm DD.MM.YYYY")
  }

  get getAddress() {
    return this.person.AddressChain.map(lev => lev.Name).join(', ')
  }
}
</script>

<style lang="scss" scoped>
.person-container {
  display: flex;
  flex-direction: column;
  max-width: 320px;

  height: auto;
  clear: both;
  overflow: auto;
  margin-bottom: 4px;
  background-color: white;
  border-radius: 5px;
  border-radius: 5px;
  border: 1px solid $accent;
  padding: 10px;

  row-gap: 8px;
}

.green-name-text {
  font-weight: 400;
  color: $primary;
}
</style>
